export const REBUILD_ROUTE_PROVIDER_INDICATORS_E2E =
  "rebuild-route-provider-indicators";

export const REBUILD_ROUTE_PROVIDER_INDICATOR_LAST_USED_E2E =
  "rebuild-route-provider-indicator-last-used";

export const REBUILD_ROUTE_PROVIDER_LAST_USED_TOOLTIP_OFFSET: [number, number] =
  [-14, 0];

export const REBUILD_ROUTE_PROVIDER_SYSTEM_DEFAULT_TOOLTIP_OFFSET: [
  number,
  number,
] = [14, 0];

/** Default FramerTooltip enter delay is 550ms; rebuild dropdown uses 2x to avoid blocking clicks. */
export const REBUILD_ROUTE_DROPDOWN_TOOLTIP_MOUSE_ENTER_DELAY_MS = 1100;

/** Info (i) icons: show tooltip immediately on hover. */
export const REBUILD_ROUTE_DROPDOWN_INFO_TOOLTIP_MOUSE_ENTER_DELAY_MS = 0;
